// Zuvesa header chrome: sticky-header scroll state + visitor dark/light toggle,
// matching seli-v2's PublicMenu (useScrolled) and ThemeModeButton behaviour.
(function () {
    var STORAGE_KEY = 'zv-color-scheme';
    var SCROLL_THRESHOLD = 20;

    var header = document.getElementById('gh-head');
    if (header) {
        var onScroll = function () {
            header.classList.toggle('zv-scrolled', window.scrollY > SCROLL_THRESHOLD);
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
    }

    var toggle = document.querySelector('[data-zv-theme-toggle]');
    if (toggle) {
        var isDark = function () {
            return document.documentElement.classList.contains('dark-mode');
        };

        toggle.setAttribute('aria-pressed', String(isDark()));

        toggle.addEventListener('click', function () {
            var html = document.documentElement;
            var next = isDark() ? 'light' : 'dark';

            html.classList.remove('auto-color');
            html.classList.toggle('dark-mode', next === 'dark');
            toggle.setAttribute('aria-pressed', String(next === 'dark'));

            try {
                window.localStorage.setItem(STORAGE_KEY, next);
            } catch (e) {}
        });
    }
})();
